import { h } from 'vue';
import { TYPE } from 'vue-toastification';
import CFToastCloseButton from '@/shared/components/CFToastCloseButton.vue';
import CFIcon from '@/ui/Icon/CFIcon.vue';

export default {
    shareAppContext: true,
    position: 'bottom-right',
    toastClassName: 'cyberfusion-toast',
    toastBodyClassName: 'cyberfusion-toast-body',
    hideProgressBar: true,
    pauseOnHover: true,
    showCloseButtonOnHover: false,
    closeButton: CFToastCloseButton,
    closeOnClick: false,
    draggable: false,
    newestOnTop: true,
    timeout: 4000,
    transition: 'Vue-Toastification__fade',
    toastDefaults: {
        [TYPE.ERROR]: {
            icon: () =>
                h(CFIcon, {
                    name: 'alert-triangle',
                    variant: 'bold',
                    size: 20,
                }),
        },
        [TYPE.SUCCESS]: {
            icon: () =>
                h(CFIcon, {
                    name: 'information-circle',
                    variant: 'bold',
                    size: 20,
                }),
        },
    },
};
